module.exports = __webpack_public_path__ + "img/slide1.1e11ff16.png";